// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610231336/js/" + chunkId + "." + {"44":"876894a1","225":"170eabaa","481":"42ccb34b","486":"a2464b17","770":"e2e86851"}[chunkId] + ".0.6763117292393275.chunk.js";
};